import { render, staticRenderFns } from "./warehousearchives.vue?vue&type=template&id=6aea4058&scoped=true&"
import script from "./warehousearchives.vue?vue&type=script&lang=js&"
export * from "./warehousearchives.vue?vue&type=script&lang=js&"
import style0 from "./warehousearchives.vue?vue&type=style&index=0&id=6aea4058&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aea4058",
  null
  
)

export default component.exports